import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { GetEventCategoriesResponse } from '~types/api/event';

export function useGetEventSubcategories(event_id?: number) {
  return useQuery<GetEventCategoriesResponse, Error>(
    ['userEventCategories', event_id],
    async () => {
      const token = useUserStore.getState().token;
      const response = await fetch(`${BASE_API_URL}events/${event_id}/subcategories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to create the event');
      }

      const data = await response.json();

      return data as GetEventCategoriesResponse;
    },
    {
      enabled: !!event_id,
    },
  );
}
